import axios from 'axios';
import { triggerLogoutEvent } from '../context/AuthProvider';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const sessionData = JSON.parse(sessionStorage.getItem('userData'));
    if (sessionData?.token) {
      config.headers['Authorization'] = `Bearer ${sessionData.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  });

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle errors
    if (error?.response?.status === 498) {
      triggerLogoutEvent("/login");
      throw new Error(error.response?.data?.message || "Session timed out");
    }
    if (error.response) {
      // Notify specific error message from server response
      let error_msg = error.response?.data?.message;
      if (error_msg) {
        error_msg = error_msg.charAt(0).toUpperCase() + error_msg.slice(1).toLowerCase();
      }
      throw new Error(error_msg || "Something went wrong");
    } else if (error.request) {
      // The request was made but no response was received
      throw new Error("Unable to complete the request. Please try again later.");
    } else {
      // Something happened in setting up the request that triggered an error
      throw new Error("Something went wrong. Please try again.");
    }
  }
);

export default axiosInstance;
